import { render, staticRenderFns } from "./ConQaManagement.vue?vue&type=template&id=1f4dfe82"
import script from "./ConQaManagement.vue?vue&type=script&lang=js"
export * from "./ConQaManagement.vue?vue&type=script&lang=js"
import style0 from "./ConQaManagement.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports